/* eslint-disable no-console */

const extractBackendMessage = (data) => {
  const errors = data?.errors;
  if (Array.isArray(errors) && errors.length > 0) return errors[0];
  return data?.message ?? data?.error ?? JSON.stringify(data);
};

const buildRequestURL = (error, baseRoute) => {
  if (error?.config?.baseURL != null) {
    return `${error.config.baseURL.replace(/\/$/, '')}${baseRoute}`;
  }
  return baseRoute;
};

/**
 * Shared HTTP service error logger.
 * Extracts status, URL, and backend message from Axios-style errors.
 *
 * @param {Error} error - Axios error (or any error with response/config)
 * @param {Object} options
 * @param {string} options.serviceName - Identifier shown in log prefix, e.g. 'platform nav'
 * @param {string} options.baseRoute - API route used for the request
 */
const logServiceError = (error, { serviceName, baseRoute }) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const requestURL = buildRequestURL(error, baseRoute);
  const backendMessage = extractBackendMessage(data);

  console.error(
    `[POV] ${serviceName}: request failed.`,
    'URL:',
    requestURL,
    'Status:',
    status ?? 'N/A (e.g. network/CORS)',
    'Message:',
    error?.message || error,
    'Backend:',
    backendMessage,
  );
};

export default logServiceError;
